// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.endpoint-table-card {
    background: #fff;
    border-radius: 12px;
    /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06); */
    padding: 16px;
}

.endpoint-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}

.endpoint-table thead th {
    background: #eef4ff;
    font-weight: 500;
    padding: 14px 12px;
    text-align: left;
    border-bottom: 1px solid #dbe7ff;
}

.th-content {
    display: flex;
    align-items: center;
    gap: 6px;
}

.sort-icon {
    cursor: pointer;
    color: #9aa4b2;
    transition: transform 0.2s;
}

.sort-icon.active {
    color: #2563eb;
}

.sort-icon.desc {
    transform: rotate(180deg);
}

.endpoint-table tbody tr {
    height: 56px;
}

.endpoint-table tbody tr:hover {
    background: #f8fbff;
}

.endpoint-table td {
    padding: 12px;
    border-bottom: 1px solid #edf2ff;
}

.response-summary-cell {
    max-width: 320px;
    white-space: normal;
    word-break: break-word;
    /* overflow-wrap: anywhere; */
    overflow-y: auto;
}

.status-pill {
    /* padding: 4px 10px; */
    padding: 7px 15px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 500;
}

/* 200 */
.status-green {
    background-color: #dcfce7;
    color: #166534;
}

/* 300–399 */
.status-yellow {
    background-color: #fef9c3;
    color: #854d0e;
}

/* 400–499 */
.status-orange {
    background-color: #ffedd5;
    color: #9a3412;
}

/* 500–599 */
.status-red {
    background-color: #fee2e2;
    color: #991b1b;
}

/* fallback */
.status-default {
    background-color: #e5e7eb;
    color: #374151;
}

.status-200 {
    background: #dcfce7;
    color: #166534;
}

.status-301 {
    background: #fff7ed;
    color: #9a3412;
}

.status-402,
.status-503 {
    background: #fee2e2;
    color: #991b1b;
}

.risk-yes {
    color: #dc2626;
    font-weight: 500;
}

.risk-no {
    color: #6b7280;
}

.action-cell svg {
    cursor: pointer;
    margin-right: 12px;
    color: #2563eb;
}

.endpoint-table .table-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    color: #6b7280;
}

.endpoint-table .pagination {
    display: flex;
    align-items: center;
    gap: 10px;
}

.endpoint-table .pagination svg {
    cursor: pointer;
}

.endpoint-table .pagination svg.disabled {
    cursor: not-allowed;
    color: #cbd5e1;
}`, "",{"version":3,"sources":["webpack://./src/components/HealthAnalytic/EndpointStatusTable.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gDAAgD;IAChD,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA,QAAQ;AACR;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,YAAY;AACZ;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,YAAY;AACZ;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,YAAY;AACZ;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,aAAa;AACb;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB","sourcesContent":[".endpoint-table-card {\n    background: #fff;\n    border-radius: 12px;\n    /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06); */\n    padding: 16px;\n}\n\n.endpoint-table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n}\n\n.endpoint-table thead th {\n    background: #eef4ff;\n    font-weight: 500;\n    padding: 14px 12px;\n    text-align: left;\n    border-bottom: 1px solid #dbe7ff;\n}\n\n.th-content {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.sort-icon {\n    cursor: pointer;\n    color: #9aa4b2;\n    transition: transform 0.2s;\n}\n\n.sort-icon.active {\n    color: #2563eb;\n}\n\n.sort-icon.desc {\n    transform: rotate(180deg);\n}\n\n.endpoint-table tbody tr {\n    height: 56px;\n}\n\n.endpoint-table tbody tr:hover {\n    background: #f8fbff;\n}\n\n.endpoint-table td {\n    padding: 12px;\n    border-bottom: 1px solid #edf2ff;\n}\n\n.response-summary-cell {\n    max-width: 320px;\n    white-space: normal;\n    word-break: break-word;\n    /* overflow-wrap: anywhere; */\n    overflow-y: auto;\n}\n\n.status-pill {\n    /* padding: 4px 10px; */\n    padding: 7px 15px;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n/* 200 */\n.status-green {\n    background-color: #dcfce7;\n    color: #166534;\n}\n\n/* 300–399 */\n.status-yellow {\n    background-color: #fef9c3;\n    color: #854d0e;\n}\n\n/* 400–499 */\n.status-orange {\n    background-color: #ffedd5;\n    color: #9a3412;\n}\n\n/* 500–599 */\n.status-red {\n    background-color: #fee2e2;\n    color: #991b1b;\n}\n\n/* fallback */\n.status-default {\n    background-color: #e5e7eb;\n    color: #374151;\n}\n\n.status-200 {\n    background: #dcfce7;\n    color: #166534;\n}\n\n.status-301 {\n    background: #fff7ed;\n    color: #9a3412;\n}\n\n.status-402,\n.status-503 {\n    background: #fee2e2;\n    color: #991b1b;\n}\n\n.risk-yes {\n    color: #dc2626;\n    font-weight: 500;\n}\n\n.risk-no {\n    color: #6b7280;\n}\n\n.action-cell svg {\n    cursor: pointer;\n    margin-right: 12px;\n    color: #2563eb;\n}\n\n.endpoint-table .table-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 0;\n    color: #6b7280;\n}\n\n.endpoint-table .pagination {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.endpoint-table .pagination svg {\n    cursor: pointer;\n}\n\n.endpoint-table .pagination svg.disabled {\n    cursor: not-allowed;\n    color: #cbd5e1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
